import { LOCAL_BASE_URL } from "../constants/constants";
import axiosRequestInterceptor from "../interceptor/axiosAPIRequestInterceptor";
import { logger } from "../utils/logger";

export const getBlogs = async () => {
	try {
		const response = await axiosRequestInterceptor.get(`/blogs/getblogs`);
		logger.log("Response from getBLogs: ", response?.data);
		return { data: response?.data?.data };
	} catch (error) {
		return { error: error.response.data.error, data: { NOTES: [] } };
	}
};

export const getBlog = async (id) => {
	try {
		const response = await axiosRequestInterceptor.get(`/blogs/getblog/${id}`);
		logger.log("Response from getBlog: ", response?.data);
		return { data: response?.data?.data };
	} catch (error) {}
};
